<form [formGroup]="formGroup">
    <div class="formWrapper">
        <span>
            Select a predefined list of documents to populate the document requests
        </span>
        <lsq-select
            [disabled]="selectListDisabled"
            id="document-list-select"
            [options]="documentListOptions"
            [formControlName]="'documentListSelect'"
            [group]="formGroup"
            label="Select Document List*"
            (ngModelChange)="handleDocumentListChange($event)"
        ></lsq-select>
        <div class="documents-list-item-box">
            <div *ngFor="let title of documentTitles">
                <lsq-label label="{{ title }}"> </lsq-label>
            </div>
        </div>
        <dr-schedule-document-request
            [formGroup]="formGroup"
            *ngIf="schemaType !== 'Prospect'"
        ></dr-schedule-document-request>
        <span>
            Please note, once you confirm, the documents above will be added as requested documents
            and the corresponding users will be notified.
        </span>

        <div class="invite-error" *ngIf="formGroup.errors?.err">
            {{ formGroup.errors?.err }}
        </div>
    </div>
</form>
